import { getFirebase, ReactReduxFirebaseProvider } from 'react-redux-firebase';
export type inittodoFB = {
    id: string, createdAt: string,
    title: string,  desc: string,  todoId: number,    
    userId: number,    completed: string,   tags: string
}

export type inittodoFBNoId = {
  createdAt: string,
  title: string,  desc: string,  todoId: number,    
  userId: number,    completed: string,   tags: string
}
type todoId = string ;

export const addTodo = (todoItem: inittodoFBNoId, uem: string) => {
  return (dispatch: Function, getState: Function, getFirebas: any) => {
    const firestore = getFirebase().firestore();
    firestore.collection(`User-${uem}`).add(todoItem)
    .then(() => {
      dispatch({ type: 'TodoAdd', todoItem, uem });
    })
    .catch((err: any) => {
      dispatch({ type: 'Error', err });
    });
  };
};


export const deleteTodo = (todoItem: inittodoFB, uem: string) => {
  return (dispatch: Function, getState: Function, getFirebas: any) => {
    const firestore = getFirebase().firestore();
    firestore.collection(`User-${uem}`).doc(`${todoItem.id}`).delete()
    .then(() => {
      dispatch({ type: 'TodoDelete', todoItem, uem });
    })
    .catch((err: any) => {
      dispatch({ type: 'Error', err });
    });
  };
};


export const completeTodo = (todoItem: inittodoFB , checked: boolean, uem: string) => {
  return (dispatch: Function, getState: Function, getFirebas: any) => {
    const firestore = getFirebase().firestore();
    firestore.collection(`User-${uem}`).doc(`${todoItem.id}`).update({ completed: `${ (checked === false) ? 'false' : 'true' }`  })
    .then(() => {
      dispatch({ type: 'TodoComplete', todoItem , checked, uem });
    })
    .catch((err: any) => {
      dispatch({ type: 'Error', err });
    });
  };
}    

export const updateTodo = (todoItem: inittodoFB , val1: string, val2: string, uem: string) => {
  const dt = new Date();
  return (dispatch: Function, getState: Function, getFirebas: any) => {
    const firestore = getFirebase().firestore();
    firestore.collection(`User-${uem}`).doc(`${todoItem.id}`).update({ 
      title: `${val1}`, desc: `${val2}`, createdAt: `${dt.toLocaleString().substring( 0, dt.toLocaleString().indexOf(",") )}`
    })
    .then(() => {
      dispatch({ type: 'TodoUpdate', todoItem , val1, val2, uem });
    })
    .catch((err: any) => {
      dispatch({ type: 'Error', err });
    });
  };
}    
